import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { BooksReducerHandlers, GeneralReducerHandlers } from './handlers';
import { GeneralActionTypes } from '../actions/types';

const booksReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    ...BooksReducerHandlers.fetchProjectOverviewDataByProjectId,
    ...BooksReducerHandlers.fetchProjectOverviewDataByCustomerId,
    ...BooksReducerHandlers.fetchTimelineDataByCustomer,
    ...BooksReducerHandlers.fetchChaptersAndResourcesByProjectId,
    ...BooksReducerHandlers.getBookSampleAndResourcesByProjectId,
    ...BooksReducerHandlers.fetchChaptersAndResourcesByUser,
    ...BooksReducerHandlers.getBookSampleAndResourcesByUser,
    ...BooksReducerHandlers.submitBookDraftToEditorByWriter,
    ...BooksReducerHandlers.sendBookDraftToCustomerByEditor,
    ...BooksReducerHandlers.approveBookDraftByCustomer,
    ...BooksReducerHandlers.sendBookDraftCustomerFeedback,
    ...BooksReducerHandlers.sendBookDraftEditorFeedback,
    ...BooksReducerHandlers.sendBookOutlineEditorFeedback,
    ...BooksReducerHandlers.sendBookOutlineCustomerFeedback,
    ...BooksReducerHandlers.sendBookOutlineWriterFeedback,
    ...BooksReducerHandlers.updateSpecificField,
    ...BooksReducerHandlers.sendDraftToCustomerByWriter,
    ...BooksReducerHandlers.sendPDFToMyEmail,
    ...BooksReducerHandlers.submitBookDraftToEditorByDevelopmentalEditor,
    ...BooksReducerHandlers.saveChaptersChanges,
    ...BooksReducerHandlers.saveUserIdWhoReadNotificationDraftWasEdited,
    ...BooksReducerHandlers.addCommentToBookSample,
    ...BooksReducerHandlers.deleteCommentInBookSample,
    ...BooksReducerHandlers.resolveCommentInBookSample,
    ...BooksReducerHandlers.updateCommentInBookSample,
    ...BooksReducerHandlers.addReplyToCommentInBookSample,
    ...BooksReducerHandlers.updateReplyToCommentInBookSample,
    ...BooksReducerHandlers.deleteOrUndoComments,
    ...BooksReducerHandlers.sendPDFToPrinter,
    ...BooksReducerHandlers.fetchProofDataByProjectId,
    ...BooksReducerHandlers.fetchProofDataByUserId,
    ...BooksReducerHandlers.getBookAndResourcesByProjectId,
    ...BooksReducerHandlers.getBookAndResourcesByCustomerId,
    ...BooksReducerHandlers.approveCoverByCustomer,
    ...BooksReducerHandlers.getInterviewsInfo,
    ...BooksReducerHandlers.completeInterviewStage,
    ...BooksReducerHandlers.fetchPhotosAndResources,
    ...BooksReducerHandlers.sendPhotosUploadInfo,
    ...BooksReducerHandlers.addPhotoByProjectId,
    ...BooksReducerHandlers.addMultiplePhotos,
    ...BooksReducerHandlers.updateMultiplePhotos,
    ...BooksReducerHandlers.updatePhoto,
    ...BooksReducerHandlers.approveOutlineByEditor,
    ...BooksReducerHandlers.approveOutlineByCustomer,
    ...BooksReducerHandlers.submitOutlineByWriter,
    ...BooksReducerHandlers.approveFinalProofByCustomer,
    ...BooksReducerHandlers.approveFinalProofByEditor,
    ...BooksReducerHandlers.editorSendDraftToDevelopmentalEditor,
    ...BooksReducerHandlers.editorSendDraftToProProofreader,
    ...BooksReducerHandlers.uploadDocumentToGoogleDocx,
    ...BooksReducerHandlers.updateCoverCopy,
    ...BooksReducerHandlers.updateCoverOptions,
    ...BooksReducerHandlers.chooseCoverPhoto,
    ...BooksReducerHandlers.replaceCoverPhoto,
    ...BooksReducerHandlers.deleteCoverPhotos,
    ...BooksReducerHandlers.addCoverPhoto,
    ...BooksReducerHandlers.onCloseOnboardingFeedbackModal,
    ...BooksReducerHandlers.addCommentToField,
    ...BooksReducerHandlers.deleteCommentByFieldName,
    ...BooksReducerHandlers.resolveCommentByFieldName,
    ...BooksReducerHandlers.updateCommentByFieldName,
    ...BooksReducerHandlers.addReplyToCommentByFieldName,
    ...BooksReducerHandlers.updateReplyToCommentByFieldName,
    ...BooksReducerHandlers.saveBookSampleChanges,
    ...BooksReducerHandlers.approveBookSampleByCustomer,
    ...BooksReducerHandlers.saveStyleSamplesChanges,
    ...BooksReducerHandlers.getProjectAndBookData,
    ...BooksReducerHandlers.approveStyleSampleByCustomer,
    ...BooksReducerHandlers.approveSampleByWriter,
    ...BooksReducerHandlers.approveSampleByEditor,
    ...BooksReducerHandlers.fetchDataToEditProject,
    ...BooksReducerHandlers.submitSpecification,
    ...BooksReducerHandlers.saveSpecification,
    ...BooksReducerHandlers.uploadCustomPDF,
    ...BooksReducerHandlers.uploadCustomCover,
    ...BooksReducerHandlers.addCommentToPDF,
    ...BooksReducerHandlers.resolvePdfComment,
    ...BooksReducerHandlers.deletePdfComment,
    ...BooksReducerHandlers.addReplyToPdfComment,
    ...BooksReducerHandlers.editPdfComment,
    ...BooksReducerHandlers.approveDraftByContentTeam,
    ...BooksReducerHandlers.submitBookDraftToEditorByProProofreader,
    ...BooksReducerHandlers.proofRequestReview,
  },
);

export default booksReducer;
